import React, { useState, useEffect } from "react";
import axios from "axios";

const EleTransportViewer = ({ materialId }) => {
  const [propsData, setPropsData] = useState({});
  const [selectedProp, setSelectedProp] = useState("");
  const [selectedDir, setSelectedDir] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [traceUrl, setTraceUrl] = useState(null);  // 👈 新增 trace 链接
  const [error, setError] = useState(null);
  const backendUrl = process.env.REACT_APP_BASE_URL || "";

  // 获取该材料的属性和方向
  useEffect(() => {
    const fetchProps = async () => {
      try {
        const res = await axios.get(`/api/ele/${materialId}/properties`);
        setPropsData(res.data);
      } catch (err) {
        setError("Error loading properties.");
        console.error("Props Error:", err);
      }
    };

    const fetchTrace = async () => {
      try {
        const res = await axios.get(`/api/ele/${materialId}/trace`);
        setTraceUrl(res.data.trace_url);
      } catch (err) {
        console.error("Error fetching trace file:", err);
      }
    };

    fetchProps();
    fetchTrace();
  }, [materialId]);

  // 获取 PDF 文件
  useEffect(() => {
    if (!selectedProp || !selectedDir) return;

    const fetchPdf = async () => {
      try {
        // ✅ 获取文件时，必须加上 responseType: 'blob'
        const res = await axios.get(
          `/api/ele/${materialId}/property/${selectedProp}/${selectedDir}`,
          { responseType: 'blob' }
        );

        const url = URL.createObjectURL(res.data);
        setPdfUrl(url);
      } catch (err) {
        setError("Error loading PDF.");
        console.error(err);
      }
    };

    fetchPdf();
  }, [selectedProp, selectedDir, materialId]);

  return (
    <div>
      <h3>Electrical Transport Properties Viewer</h3>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* trace 文件下载按钮 */}
      {traceUrl && (
        <div style={{ marginBottom: "15px" }}>
          <a
            href={traceUrl}
            download
            style={{
              padding: "8px 12px",
              background: "#007bff",
              color: "white",
              borderRadius: "5px",
              textDecoration: "none",
            }}
          >
            ⬇ Download Trace File
          </a>
        </div>
      )}

      {/* 属性选择框 */}
      <div style={{ marginBottom: "10px" }}>
        <label>Property: </label>
        <select
          value={selectedProp}
          onChange={(e) => {
            setSelectedProp(e.target.value);
            setSelectedDir(""); // 重置方向
            setPdfUrl(null);   // 切换属性时清空 PDF
          }}
        >
          <option value="">-- Select Property --</option>
          {Object.keys(propsData).map((prop) => (
            <option key={prop} value={prop}>
              {prop}
            </option>
          ))}
        </select>
      </div>

      {/* 方向选择框 */}
      {selectedProp && (
        <div style={{ marginBottom: "10px" }}>
          <label>Direction: </label>
          <select
            value={selectedDir}
            onChange={(e) => {
              setSelectedDir(e.target.value);
              setPdfUrl(null); // 切换方向时清空 PDF
            }}
          >
            <option value="">-- Select Direction --</option>
            {propsData[selectedProp].map((dir) => (
              <option key={dir} value={dir}>
                {dir}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* PDF 显示 */}
      {pdfUrl && (
        <div style={{ flex: 1 }}>
          <iframe
            src={pdfUrl}
            width="100%"
            height="600px"
            style={{ border: "none" }}
            title="Transport Property PDF"
          />
        </div>
      )}
    </div>
  );
};

export default EleTransportViewer;
